import React from 'react';
import { Button, BackButton, ResultValue, PrintButton } from '../Components/Simple';
import { BasicInformation, ClaimDetails, FactorAndAdjustments, PricingErrors, ServiceLineItems } from '../Components/Combined/Results';
import { PFS as modelType } from '../Constants/modelTypes';
import { formatStringAsCurrency, cleanUpNumberString, formatDateString } from '../Utils/stringUtils';
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../Constants/stringFormats';
import { useNavigate, useLocation } from 'react-router-dom';
import usePrintOrientation from '../Hooks/usePrintOrientation';
import PTPAddOnEditResults from '../Components/Results/PTPAddOnEditResults';
import Protect from '../Components/Combined/Protect';
import { HIDE } from '../Constants/protectionBehaviors';
import { EOB_VIEW } from '../Constants/moduleNames';
import { enableEOB } from '../Utils/features';

export default function PFSResult() {
    const [_orientation, _setOrientation] = usePrintOrientation('landscape');
    const location = useLocation();
    const navigate = useNavigate();
    const { result, calendarYear, lines, ptpAddOnServiceMode } = location.state;

    const processedDate = new Date();
    const totalMedicareAllowed = result.services && result.services.map(s => cleanUpNumberString(s.medicareAllowed)).reduce((p, v) => p + Number(v), 0);

    const handleNavigateToEOBGenerator = () => {
        navigate('/EOB', {
            state: {
                processedDate,
                pricerType: modelType,
                lines: result.services.map(responseLine => {
                    const medicareAllowedAsFloat = parseFloat(cleanUpNumberString(responseLine.medicareAllowed)) || 0;
                    return {
                        dateOfService: formatDateString(responseLine.serviceDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT) || "",
                        serviceCode: responseLine.procCode || "",
                        serviceDescription: responseLine.serviceDescription || "",
                        qty: parseFloat(cleanUpNumberString(responseLine.adjUnits)) || "",
                        billedAmount: parseFloat(cleanUpNumberString(responseLine.billed)) || 0,
                        allowedAmount: medicareAllowedAsFloat,
                        initialMaxShiftAmount: calculateInitialMaxShiftAmount(responseLine.procCode, result.specialtyCode)
                    }
                })
            }
        });
    };

    return (<div className="py-2">
        <div className="row g-0 sticky top border-bottom">
            <div className="row justify-content-between g-0">
                <div className="col-auto">
                    <PrintButton />
                </div>
                <div className="col-auto">
                    <Protect module={EOB_VIEW} behavior={HIDE} >
                        {enableEOB && <Button className="btn btn-success" onClick={handleNavigateToEOBGenerator} text="Generate EOB" />}
                    </Protect>
                </div>
                <div className="col-auto">
                    <BackButton />
                </div>
            </div>
            <div className="row my-2 g-0">
                <div className="col">
                    <h2>Professional Pricer - Pricing Outputs</h2>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <ResultValue label="Medicare Allowed Amount" value={formatStringAsCurrency(totalMedicareAllowed)} labelClassName="fs-4 fw-500" valueClassName="fs-4 fw-500" />
            </div>
        </div>
        <PricingErrors result={result} totalMedicareAllowed={totalMedicareAllowed} />
        <div className="row my-2">
            <div className="col-md-6">
                <BasicInformation calendarYear={calendarYear} result={result} model={modelType} processedDate={processedDate} />
            </div>
        </div>
        <div className="row my-2">
            <div className="col-md">
                <ClaimDetails result={result} model={modelType} />
            </div>
            <div className="col-md">
                <FactorAndAdjustments result={result} model={modelType} />
            </div>
        </div>
        <PTPAddOnEditResults result={result} serviceMode={ptpAddOnServiceMode} />
        <div className="page-break-here"></div>
        <div className="row my-2">
            <div className="col">
                <ServiceLineItems result={result} model={modelType} inputLines={lines} />
            </div>
        </div>
    </div>
    );
}


const calculateInitialMaxShiftAmount = (procCode, specialtyCode) => {
    const pcpSpecialtyCodes = ["01", "08", "11", "37", "38", "50", "84", "97", "C6", "X7", "Y8", "Y9"];
    const procCodeAsInt = parseInt(procCode);

    if (procCodeAsInt && (99201 <= procCodeAsInt && procCodeAsInt <= 99205 || 99211 <= procCodeAsInt && procCodeAsInt <= 99215 || procCodeAsInt === 99396)) {
        if (specialtyCode && pcpSpecialtyCodes.includes(specialtyCode)) {
            return 25;
        }
        else {
            return 50;
        }
    }

    return 0
}
